import type { ModalInfoProps } from '@/components/ModalInfo';
import { ModalInfo } from '@/components';
import { Flex, Box, ArrowUpRightBoxIcon } from '@blockanalitica/ui';

export default function SavingsModal({ ...rest }: Partial<ModalInfoProps>) {
  return (
    <ModalInfo title="What is Savings?" {...rest}>
      <Flex flexDirection="column" gap="2xs">
        <Box>
          Savings product allows users to easily supply various stablecoins and
          receive Savings USDS (sUSDS) tokens in return. These tokens represent
          a digital record of your USDS interaction with the Sky Savings module
          and any value accrued to your position, which compounds automatically
          in real-time, growing your balance of USDS. As your savings
          accumulate, the value of sUSDS increases over time. You can withdraw
          your funds by exchanging sUSDS for the stablecoin of your choice, with
          no fees or slippage.
        </Box>
        <Flex
          as="a"
          display="inline-flex"
          // @ts-ignore
          href="https://docs.spark.fi/user-guides/earning-savings/"
          target="_blank"
          rel="noopener noreferrer">
          Learn more
          <ArrowUpRightBoxIcon size="-1" />
        </Flex>
      </Flex>
    </ModalInfo>
  );
}
